import { render, staticRenderFns } from "./PPCMInputReceive.vue?vue&type=template&id=6043727a&scoped=true&"
import script from "./PPCMInputReceive.vue?vue&type=script&lang=js&"
export * from "./PPCMInputReceive.vue?vue&type=script&lang=js&"
import style0 from "./PPCMInputReceive.vue?vue&type=style&index=0&id=6043727a&prod&scoped=true&lang=css&"
import style1 from "../Inspection/PPCMInputInspection.scss?vue&type=style&index=1&id=6043727a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6043727a",
  null
  
)

export default component.exports